import React from "react";

import { observer } from "mobx-react";

import { FiscalizationItem } from "../BetDetailsModalFiscalization";
import { useTranslation } from "react-i18next";

export const TransactionSignature = observer(
	function TransactionSignature(props: {
		firstFinishedTransaction: FiscalizationItem;
	}) {
		const { t } = useTranslation("mybets");

		const { firstFinishedTransaction } = props;

		return (
			<div className="bet__details__row table--bet__fiscalization__row">
				<div className="bet__details__col table--bet__fiscalization__data">
					{t("mybets:ITEM.ADDITIONAL_SIGNATURE")}:
				</div>
				<div className="bet__details__col table--bet__fiscalization__data">
					{firstFinishedTransaction.signature}
				</div>
			</div>
		);
	}
);
